import { KeyboardTypeEnum } from '@inter-ikea-kompis/keyboard-manager';

interface ICallbacks {
  onDone?: () => any;
  onKeyPress?: (keyCode: string) => any;
}

interface IRootFunctions {
  setInputType: (type: string) => void;
  keyboardToggle: (state: boolean) => void;
}

const useKeyboard = () => {
  const dummyFunc = () => {};
  let _onDoneCallback: () => any = dummyFunc;
  let _onKeyPressCallback: (keyCode: string) => any = dummyFunc;
  let _keyboardTypeSetter: ((type: KeyboardTypeEnum) => any) | null = null;
  let _keyboardToggle: ((state: boolean) => any) | null = null;

  const onDone = () => {
    _onDoneCallback();
    _onDoneCallback = dummyFunc;
    _onKeyPressCallback = dummyFunc;
  };

  const registerCallbacks = ({ onDone, onKeyPress }: ICallbacks) => {
    if (onDone) _onDoneCallback = onDone;
    if (onKeyPress) _onKeyPressCallback = onKeyPress;
  };

  const onKeyPress = (keyCode: string) => _onKeyPressCallback(keyCode);

  const showKeyboard = () => _keyboardToggle && _keyboardToggle(true);

  const hideKeyboard = () => _keyboardToggle && _keyboardToggle(false);

  const setInputType = (type: KeyboardTypeEnum) =>
    _keyboardTypeSetter && _keyboardTypeSetter(type);

  const registerRootFunctions = ({
    setInputType,
    keyboardToggle,
  }: IRootFunctions) => {
    if (_keyboardToggle || _keyboardTypeSetter) return;

    _keyboardTypeSetter = setInputType;
    _keyboardToggle = keyboardToggle;
  };

  return {
    showKeyboard,
    hideKeyboard,
    registerCallbacks,
    onDone,
    onKeyPress,
    setInputType,
    registerRootFunctions,
  };
};

export default useKeyboard();
